import { _ } from "core-js";

export default {
  namespaced: true,
  state: {
    businessLoyality: {
      name: '',
    },
    detail: {
      id: "",
      name: "",
      slug: "",
      branding: {
        logo_url: "",
        primary_color: "",
        secondary_color: "",
        accent_color: ""
      }
    }
  },
  getters: {
    detail: state => state.detail,
    businessLoyality: state => state.businessLoyality,
    hasBusinessLoyalityProgram: state => {
      if( _.isEmpty(state.businessLoyality)){
        return false;
      } else if(state.businessLoyality.is_active){
        return true;
      } else {
        return false;
      }
    }
  },
  mutations: {
      detailMutate(state, data) {
        state.detail = data;
      },
      businessLoyalityMutate(state, data) {
        state.businessLoyality = data;
    }
  },
  actions: {
      setDetail(context, data) {
        context.commit('detailMutate', data)
      },
      setBusinessLoyality(context, data) {
        context.commit('businessLoyalityMutate', data)
      },
      resetDetail(context, data) {
        context.commit('detailMutate', {
          id: "",
          name: "",
          branding: {
            logo_url: "",
            primary_color: "",
            secondary_color: "",
            accent_color: ""
          }
        });
      }
  }
}